import React from 'react';
import { Link } from 'react-router-dom';

export default function AuthorWidget({ imgUrl, name, description }) {
  return (
    <div className='cs_author'>
      <div className='cs_author_img'>
        <img src={imgUrl} alt={name} />
      </div>
      <div className='cs_author_right'>
        <h3>{name}</h3>
        <p className='mb-2'>{description}</p>
        <Link to={`/blog?author=${encodeURIComponent(name)}`} className=''>
          View All Posts by {name}
        </Link>
      </div>
    </div>
  );
}
